import { Autocomplete, Box, LinearProgress, TextField } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import SimpleAlert from "../../../components/display/SimpleAlert";
import { fetchDropdownTemplates } from "../../../enums/queryFunction/Fetch";
import { TEMPLATES_DROPDOWN } from "../../../enums/QueryKeys";
import { TemplateCategory } from "../../../enums/TemplateCategory";
import useUser from "../../../hooks/useUser";

export default function TemplateAutoComplete({
  handleSetValue,
  category = TemplateCategory.APPOINTMENT,
  ...rest
}) {
  const { t } = useTranslation();
  const { control } = useFormContext();
  const { currentClinic } = useUser();
  const {
    data: template,
    isLoading,
    error,
  } = useQuery({
    queryKey: [TEMPLATES_DROPDOWN + currentClinic?.id, category],
    queryFn: () => fetchDropdownTemplates(currentClinic?.id, category),
    staleTime: Infinity,
  });
  if (isLoading) {
    return <LinearProgress />;
  }
  if (error) {
    return (
      <SimpleAlert message={"ErrorFetchingTemplates"} severity={"error"} />
    );
  }
  return (
    <Controller
      control={control}
      name={"template"}
      render={({ field }) => (
        <Autocomplete
          {...field}
          value={field.value ?? null}
          onChange={(e, value) => {
            field.onChange(value);
            handleSetValue(value);
          }}
          fullWidth
          isOptionEqualToValue={(option, value) => option.title === value.title}
          options={template}
          getOptionLabel={(option) => `${option.title}`}
          renderOption={(props, option) => (
            <Box {...props} key={option.id}>
              {option.title}
            </Box>
          )}
          renderInput={(params) => (
            <TextField {...params} label={t("Templates")} variant="standard" />
          )}
          clearText={t("Clear")}
          closeText={t("Close")}
          openText={t("Open")}
        />
      )}
    />
  );
}
